/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionUnitComponent = function (unit) {
    this.unit = unit;
};

Merge2MissionUnitComponent.prototype.isMovable = function () {
    return true;
};

Merge2MissionUnitComponent.prototype.isMergeable = function () {
    return true;
};

Merge2MissionUnitComponent.prototype.canMine = function () {
    return false;
};

Merge2MissionUnitComponent.prototype.getBecomes = function () {
    return undefined;
};
